<div>
  <div class="row d-flex align-content-between">
    <div class="col-lg-6" *ngIf="!result && !loading">
      <form [formGroup]="createPasswordForm">
        <kt-alert
          *ngIf="hasFormErrors"
          type="warn"
          [duration]="30000"
          [showCloseButton]="true"
          (closeAl)="onAlertClose()"
        >
          <span>{{ error }}</span>
        </kt-alert>
        <div id="hiddenUser" style="width: 0; height: 0; overflow: hidden">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>Username</mat-label>
            <input matInput placeholder="Username" formControlName="username" minlength="4" />
          </mat-form-field>
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>Password</mat-label>
            <input
              autocomplete="off"
              matInput
              type="password"
              placeholder="Password"
              formControlName="password"
            />
          </mat-form-field>
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label>PIN</mat-label>
            <input matInput placeholder="PIN" formControlName="pin" />
          </mat-form-field>
        </div>
        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>Username</mat-label>
          <input
            matInput
            placeholder="Username"
            minlength="4"
            maxlength="16"
            formControlName="firstField"
            required
          />
          <mat-error *ngIf="isControlHasError('firstField', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('firstField', 'pattern')">
            <strong>{{ 'AUTH.VALIDATION.INVALID' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('firstField', 'duplicatedName')">
            <strong>{{ 'Username Already Exists Please Choose Another One' }}</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>PIN</mat-label>
          <input matInput type="text" placeholder="PIN" formControlName="secField" required />
          <mat-error *ngIf="isControlHasError('secField', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('secField', 'minLength')">
            <strong>{{ 'Minimum is 6 digits' }}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>Password</mat-label>
          <input
            autocomplete="off"
            matInput
            type="password"
            placeholder="Password"
            formControlName="pass"
            required
          />

          <mat-error *ngIf="isControlHasError('pass', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('pass', 'pattern')">
            <strong>{{ 'AUTH.VALIDATION.PATTERN_PASSWORD' | translate }} </strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="mat-form-field-fluid mb-5" appearance="fill">
          <mat-label>Retype Password</mat-label>
          <input
            matInput
            type="password"
            placeholder="Retype Password"
            formControlName="rePassword"
            required
          />
          <mat-error *ngIf="isControlHasError('rePassword', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
          <mat-error
            *ngIf="
              !isControlHasError('rePassword', 'required') &&
              createPasswordForm.get('rePassword')?.invalid
            "
          >
            <strong>{{ 'AUTH.VALIDATION.NOT_MATCH' | translate }}</strong>
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <div class="col-lg-6" *ngIf="result && !loading">
      <h4>Applications</h4>
      <div *ngFor="let app of applications">
        <div class="col d-flex justify-content-between m-3" *ngIf="app">
          <span class="role-timeline-3-item-time">
            <mat-checkbox
              [disabled]="!app.configurable || getEditAppPermission() || isViewMode"
              [(ngModel)]="app.enabled"
              (change)="checkValue(app.enabled, app.id)"
              class="font-size-sm"
            >
              {{ app.name }}
            </mat-checkbox>
          </span>
        </div>
        <div
          class="row d-flex align-items-center"
          *ngIf="app?.permissions?.length > 0"
          style="margin-left: 30px"
        >
          <div *ngFor="let perm of app.permissions">
            <span class="role-timeline-3-item-time">
              <mat-checkbox
                [disabled]="!app.configurable || getEditAppPermission() || isViewMode"
                [(ngModel)]="perm.enabled"
                (change)="changeEnable(perm.enabled, app.id, perm.id)"
                class="font-size-xs"
                style="margin-right: 15px"
              >
                {{ perm.name }}
              </mat-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6" *ngIf="loading">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </div>
  <button
    *ngIf="!this.result?.username && !isViewMode"
    type="button"
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    style="margin-top: 20px"
  >
    <span translate="GLOBAL.SAVE">Save</span>
  </button>
  <button
    *ngIf="this.result?.username && !isViewMode"
    type="button"
    mat-raised-button
    color="primary"
    (click)="updateApplications(applications)"
    style="margin-top: 20px"
  >
    <span translate="GLOBAL.SAVE">Save</span>
  </button>
</div>
